// 設定退藥盒 component

<template>
  <div>
    <div class="row upper-subpanel">
      <progressBar/>
      <transition name="slide-fade">
        <div class="upper-subpanel--without-progressbar" v-if="stage === 'loading'">
          <Loader/>
        </div>
        <div class="upper-subpanel--without-progressbar" v-else>
          <div class="row" v-if="returnCmpn !== null" style="width: 100%; height: 100%; margin: 0">
            <div class="col-12">
              <div class="upper-subpanel--half" >
                <h3>目前設定位置</h3>
                <p>
                  第 {{ returnCmpn.net.open_times }} 藥櫃 - 第 {{ returnCmpn.net.row_id }} 層 - 第 {{ returnCmpn.pos_row }} 列 - 第 {{ returnCmpn.relative_col }} 行
                </p>
                <button class="btn btn-lg confirm-button" @click="deleteReturnCmpn">刪除退藥盒</button>
              </div>
            </div>
          </div>
          <div class="row" style="width: 100%; height: 100%; margin: 0" v-else> 
            <div class="col-md-6">
              <selectBox :mode="'emptyAndF'" :singleSelect="true"/>
            </div>
            <div class="col-md-6">
              <div class="upper-subpanel--half">
                <h3>請在左側點選未使用藥盒</h3>
                <h3>以設定退藥盒</h3>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <bottom-buttons>
      <action-button slot="button-1" title="回主畫面" @click.native="cancel"/>
      <action-button slot="button-9" title="設定完成" @click.native="submit" v-if="returnCmpn === null"/>
    </bottom-buttons>

  </div>
</template>

<script>
/*
  todo: wait for backend for setting up return box.
  todo: post function for saving position.
*/
import progressBar from './flowComp/ProgressBar';
import selectBox from './flowComp/PositionSelection';
import Loader from './common/Loader';
import BottomButtons from './common/BottomButtons';


export default {
  name: 'SetReturnBox',
  components: {
    progressBar,
    selectBox,
    Loader,
    BottomButtons,
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
  },
  data() {
    return {
      stage: 'loading',
      progress: [
        {
          en: 'selectPosition',
          zh: '選擇位置',
        },
        // {
        //   en: 'confirmPosition',
        //   zh: '確認位置',
        // },
      ],
      returnCmpn: null,
      returnCmpnId: null,
    };
  },
  methods: {
    cancel() {
      this.$router.push({ name: 'Main' });
    },
    submit() {
      if (this.$store.state.device.selectedDevicesID.length !== 0) {
        this.stage = 'loading';
        this.instance.patch(`/api/system/${this.$store.getters.currentSystem.id}/`, {
          return_cmpn: this.$store.state.device.selectedDevicesID[0],
        })
        .then(() => {
          this.$store.commit('SET_MESSAGE', {
            type: 'success',
            context: '設定成功',
          });
          this.getFullReturnCmpn();
          // setInterval(() => {
          //   this.stage = 'finish';
          // }, 1000);
          // this.$router.push({ name: 'Main' });
        });
      } else {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '請先選擇位置',
        });
      }
    },
    deleteReturnCmpn() {
      this.stage = 'loading';
      this.instance.get('/api/event/', {
        params: {
          event: 'RETURN',
          device: this.$store.getters.currentSystem.return_cmpn,
          checked: false,
        },
      })
      .then((res) => {
        if (res.data.results.length > 0) {
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            context: '尚有未回收之退藥, 請先行回收再刪除退藥盒',
          });
          this.$router.push({ name: 'recycleDrug' });
        } else {
          this.instance.patch(`/api/system/${this.$store.getters.currentSystem.id}/`, {
            return_cmpn: null,
          })
          .then(async () => {
            this.$store.commit('SET_MESSAGE', {
              type: 'success',
              context: '刪除成功',
            });
            await this.$store.dispatch('getSystemInfo');
            this.returnCmpn = null;
            this.stage = 'finish';
          });
        }
      });
    },
    async getFullReturnCmpn() {
      await this.$store.dispatch('getSystemInfo');
      this.returnCmpnId = this.$store.getters.currentSystem.return_cmpn;
      console.log(this.returnCmpnId);
      // this.$store.state.systems.forEach((sys) => {
      //   if (sys.return_cmpn !== null) this.returnCmpnId = sys.return_cmpn;
      // });
      if (this.returnCmpnId !== null) {
        this.instance.get(`/api/device/${this.returnCmpnId}/`)
        .then((res) => {
          this.returnCmpn = res.data;
          this.stage = 'finish';
        });
      } else {
        this.stage = 'finish';
      }
    },
  },
  mounted() {
    this.$store.commit('SET_APP', '設定退藥盒');
    this.$store.commit('SET_CURRENT_STEP', 'selectPosition');
    this.$store.commit('SET_PROGRESS', this.progress);
    // get return cmpn
    this.getFullReturnCmpn();
  },
};
</script>

<style lang="sass">
.upper-subpanel--half
  display: flex;
  flex-flow: column;
  height: 100%;
  align-items: center;
  justify-content: center;
</style>



// WEBPACK FOOTER //
// SetReturnBox.vue?355429cb